import React from "react";
import {
  ProfileOutlined,
  IdcardOutlined,
  AuditOutlined,
  TeamOutlined,
  LeftSquareOutlined,
  RightSquareOutlined,
  EnvironmentOutlined,
  PayCircleOutlined,
  BankOutlined,
} from "@ant-design/icons";
import { getUserDataSelector } from "@quest-finance/quest-fe-shared/dist/auth";
import { useSelector } from "react-redux";
import { Link } from "react-router";
import {
  hasAccessToAssessmentAccreditations,
  hasAccessToAssessmentApplications,
  hasAccessToClients,
  hasAccessToMoveApplication,
  hasAccessToPayment,
  hasAccessToRoles,
  hasAccessToUsers,
  canViewLenders,
} from "../../../../iam/utils/permissions";
import * as abaProcess from "../../../../payment/pages/aba/process";
import { PORTALS } from "../../../../theme/constants/Layout";
import { setSidebarCollapse } from "../../../actions/creators/layout";
import { useLayoutDispatch } from "../../../dispatchers/";
import "./Sidebar.scss";

interface TwoColSidebarProps {
  collapsed?: boolean;
}

const TwoColSidebar: React.FunctionComponent<TwoColSidebarProps> = ({
  collapsed = false,
}: TwoColSidebarProps) => {
  const userData = useSelector(getUserDataSelector);
  const layoutDispatch = useLayoutDispatch();

  const onToggleHandler = () => {
    layoutDispatch(setSidebarCollapse(!collapsed));
  };

  return (
    <div className="layout-sider">
      {userData && (
        <div className="links">
          <div className="toggle-btn" onClick={onToggleHandler}>
            {collapsed ? <RightSquareOutlined /> : <LeftSquareOutlined />}
          </div>
          {hasAccessToAssessmentApplications(userData.permissions) && (
            <Link
              to="/assessment/assessments/applications"
              data-testid="assessment-menu"
            >
              <AuditOutlined />
              <span className="title">Applications</span>
            </Link>
          )}

          {hasAccessToAssessmentAccreditations(userData.permissions) && (
            <Link
              to="/assessment/assessments/accreditations"
              data-testid="accreditation-menu"
            >
              <AuditOutlined />
              <span className="title">Accreditations</span>
            </Link>
          )}

          {hasAccessToClients(userData.permissions) && (
            <Link to="/iam/clients" data-testid="client-menu">
              <TeamOutlined />
              <span className="title">Clients</span>
            </Link>
          )}
          {hasAccessToUsers(userData.permissions) && (
            <Link to="/iam/users" data-testid="user-menu">
              <IdcardOutlined />
              <span className="title">Users</span>
            </Link>
          )}
          {hasAccessToRoles(userData.permissions) && (
            <Link to="/iam/roles" data-testid="role-menu">
              <ProfileOutlined />
              <span className="title">Roles</span>
            </Link>
          )}
          {canViewLenders(userData.permissions) && (
            <Link to="/application/lenders" data-testid="lender-menu">
              <BankOutlined />
              <span className="title">Lenders</span>
            </Link>
          )}
          {hasAccessToMoveApplication(userData.permissions) && (
            <Link to="/application/applications/move">
              <EnvironmentOutlined />
              <span className="title">Move Application</span>
            </Link>
          )}
          {hasAccessToPayment(userData.permissions) && (
            <Link to="/payment/aba/process">
              <PayCircleOutlined />
              <span className="title">{abaProcess.pageTitle}</span>
            </Link>
          )}
          <div id={PORTALS.EMAILER}></div>
        </div>
      )}
    </div>
  );
};

export default TwoColSidebar;
